import React from "react";
import { default as WTablePagination } from "@mui/material/TablePagination";

function TablePagination(props) {
  return <WTablePagination {...props} />;
}

export default TablePagination;
